import { ContentHeader } from '@backstage/core-components';
import {
  CatalogFilterLayout,
  EntityLifecyclePicker,
  EntityListProvider,
  EntityTagPicker,
  EntityTypePicker,
  EntityKindPicker,
  EntityNamespacePicker,
  EntityProcessingStatusPicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import { EntityOwnerPicker } from './EntityOwnerPicker';
import { EntityRepoPicker } from './EntityRepoPicker';
import { EntityUserDepartmentPicker } from './EntityUserDepartmentPicker';
import { EntityUserLocationPicker } from './EntityUserLocationPicker';
import { EntityUserRolePicker } from './EntityUserRolePicker';
import { EntityUserTitlePicker } from './EntityUserTitlePicker';
import { EntityNamePicker } from './EntityNamePicker';
import { EntityUserGitHubUsernamePicker } from './EntityUserGitHubUsernamePicker';
import { EntityUserSlackNamePicker } from './EntityUserSlackNamePicker';
import { CatalogTable } from './CatalogTable';

export const CatalogContent = (props: {
  initialKind?: string;
  allowedKinds?: string[];
  SupportButton?: JSX.Element;
}) => {
  const { initialKind, allowedKinds, SupportButton } = props;
  return (
    <EntityListProvider>
      <ContentHeader title="">
        {SupportButton ? SupportButton : null}
      </ContentHeader>
      <CatalogFilterLayout>
        <CatalogFilterLayout.Filters>
          <EntityKindPicker
            initialFilter={initialKind ?? 'component'}
            allowedKinds={allowedKinds ?? undefined}
          />
          <EntityTypePicker />
          <UserListPicker initialFilter="all" />
          <EntityNamePicker />
          <EntityRepoPicker />
          <EntityUserGitHubUsernamePicker />
          <EntityUserSlackNamePicker />
          <EntityUserLocationPicker />
          <EntityUserDepartmentPicker />
          <EntityUserRolePicker />
          <EntityUserTitlePicker />
          <EntityOwnerPicker />
          <EntityLifecyclePicker />
          <EntityTagPicker />
          <EntityNamespacePicker />
          <EntityProcessingStatusPicker />
        </CatalogFilterLayout.Filters>
        <CatalogFilterLayout.Content>
          <CatalogTable />
        </CatalogFilterLayout.Content>
      </CatalogFilterLayout>
    </EntityListProvider>
  );
};
